/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest
    // IQueryResultSettings,
    // NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './AtpPlpDataServiceEntities.g';

// @ts-ignore
function kRV_ATPQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery(
        'KRV_ATP',
        'KRV_ATPLeadTimePropertiesDate',
        DataServiceEntities.KRV_ATPLeadTimePropertiesDateExtensionClass,
        key
    );
}

export function createKRV_GetATPLeadTimeWithDateInput(itemId: string, requestedDate: string): IDataServiceRequest {
    const query = kRV_ATPQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetATPLeadTimeWithDate',
        true,
        DataServiceEntities.KRV_ATPLeadTimePropertiesDateExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_ATPLeadTimePropertiesDate' },
        { itemId: itemId, requestedDate: requestedDate }
    );
}

export function kRV_GetATPLeadTimeWithDateAsync(
    context: IContext,
    itemId: string,
    requestedDate: string
): AsyncResult<DataServiceEntities.IKRV_ATPLeadTimePropertiesDate> {
    const request = createKRV_GetATPLeadTimeWithDateInput(itemId, requestedDate);
    return callActionOrExecute<DataServiceEntities.IKRV_ATPLeadTimePropertiesDate>(request, context.callerContext);
}

export function createKRV_GetATPLeadTimeWithQuantityInput(
    kRVATPLeadTimeQuantity: DataServiceEntities.IKRV_ATPLeadTimePropertiesQuantityRequestEntity[]
): IDataServiceRequest {
    const query = kRV_ATPQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetATPLeadTimeWithQuantity',
        true,
        DataServiceEntities.KRV_GetATPLeadTimeResponseQuantityExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_GetATPLeadTimeResponseQuantity' },
        { KRVATPLeadTimeQuantity: kRVATPLeadTimeQuantity }
    );
}

export function kRV_GetATPLeadTimeWithQuantityAsync(
    context: IContext,
    kRVATPLeadTimeQuantity: DataServiceEntities.IKRV_ATPLeadTimePropertiesQuantityRequestEntity[]
): AsyncResult<DataServiceEntities.IKRV_GetATPLeadTimeResponseQuantity> {
    const request = createKRV_GetATPLeadTimeWithQuantityInput(kRVATPLeadTimeQuantity);
    return callActionOrExecute<DataServiceEntities.IKRV_GetATPLeadTimeResponseQuantity>(request, context.callerContext);
}

export function createKRV_GetMultipleATPLeadTimeDateInput(
    kRVATPLeadTimeDate: DataServiceEntities.IKRV_ATPLeadTimePropertiesDateRequestEntity[]
): IDataServiceRequest {
    const query = kRV_ATPQuery();
    return query.createDataServiceRequestForOperation(
        'KRV_GetMultipleATPLeadTimeDate',
        true,
        DataServiceEntities.KRV_GetMultipleATPLeadTimeResponseDateExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IKRV_GetMultipleATPLeadTimeResponseDate' },
        { KRVATPLeadTimeDate: kRVATPLeadTimeDate }
    );
}

export function kRV_GetMultipleATPLeadTimeDateAsync(
    context: IContext,
    kRVATPLeadTimeDate: DataServiceEntities.IKRV_ATPLeadTimePropertiesDateRequestEntity[]
): AsyncResult<DataServiceEntities.IKRV_GetMultipleATPLeadTimeResponseDate> {
    const request = createKRV_GetMultipleATPLeadTimeDateInput(kRVATPLeadTimeDate);
    return callActionOrExecute<DataServiceEntities.IKRV_GetMultipleATPLeadTimeResponseDate>(request, context.callerContext);
}
